import type { FaireProductEntity } from "../../entity_types/product";

export const p_z66wshu3xu: FaireProductEntity = {
  token: "p_z66wshu3xu",
  type: "product",
  name: "Hot Guys Read Books Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/4e040645da557235235ab64d5bb7e35b34de7e653aa8b2af8dfaed6fabc8449f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d305b2429b10c80701c51e085acc3ac242bf4bca2ee5ca2eea825b164ec3da86.jpeg",
    "https://cdn.faire.com/fastly/0977f0d63d6a733afb01f4633f849cf254b5b9e78cba5bd574f683894228b178.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/348bc85f95e0a47971abedc8496ec1bd9f916a725ca9fed73f2eadecf0c897e2.jpeg",
    "https://cdn.faire.com/fastly/dd7becde957c4990697aa70c5c2a680f6ab647c0b9d8d2e74916ac6dd6c7d6ba.jpeg",
    "https://cdn.faire.com/fastly/239d5aff3bae4580bbb8f84b4275e455ae348c7f506b12ac417380ea1ffb715a.jpeg",
    "https://cdn.faire.com/fastly/b40a2337bf44155ddcf14d57145a63a7e70eb66a4d93fb66233e37d362368762.jpeg",
    "https://cdn.faire.com/fastly/30b68e11cc9aad446db342b27e74bbef494545caec2b441ef9cb047e04837392.jpeg"
  ],
  priceDollars: 6.75,
  description: "Socks for the guys that are expert in forewords, footnotes, and a little foreplay. Hopefully it's not just pages he'll be flipping. 🥴🥴🥴\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:14.545Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
